export default __webpack_public_path__ + "assets/icons/faqQ.f8945d3e.svg";